module.exports = __webpack_public_path__ + "img/treatment-based-options-desktop-fr.b7221908.jpg";